import { Dispatch, SetStateAction } from 'react';
import { StepNav } from '../index';
import { useScopedState } from 'informed';
import { CommonProps } from '../../layout/LoanForm';
import { BeforeAgreementsScope } from '../../model/formState';

const AgreementsHalfStepNav = ({
  t,
  open: openAgreementsModal,
  setOpen: setOpenAgreementsModal,
  isValidating: isEmailValidating,
}: CommonProps & {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>> | (() => void);
} & { isValidating: boolean }) => {
  const { valid: scopeValid } = useScopedState() as {
    valid: boolean;
    value: BeforeAgreementsScope;
  };

  const validateEmail = async () => {
    setOpenAgreementsModal(true);
  };

  const onNext = scopeValid ? (isEmailValidating ? () => {} : validateEmail) : () => {};
  return (
    <StepNav t={t} hideBack onNext={onNext} disabled={isEmailValidating || openAgreementsModal} />
  );
};

export default AgreementsHalfStepNav;
